export default __webpack_public_path__ + "static/media/doctor.cd6107f6.png";